<div id="footer" class="container-fluid">
  <div class="made_by">
    <a href="https://hoobanstudio.com" target="_blank"
      >{{ "CreatedWith" | translate }} <i class="icon-heart"></i>
      {{ "InHoobanInnovationStudio" | translate }}</a
    >
  </div>
</div>
